import React, { useState, useEffect } from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import lightLogo from '../../assets/images/brand-logo.svg';
import darkLogo from '../../assets/images/brand-logo-dark.svg';

const BluestuffLogo = ({ className = 'h-9 w-auto', alt = 'Bluestuff', variant, ...props }) => {
  const { theme } = useTheme();
  const [imgFailed, setImgFailed] = useState(false);
  const effectiveVariant = variant === 'light' || variant === 'dark' ? variant : theme;
  const src = effectiveVariant === 'dark' ? darkLogo : lightLogo;

  useEffect(() => {
    setImgFailed(false);
  }, [src]);

  if (imgFailed) {
    return (
      <span
        className={`${className} inline-flex items-center justify-center rounded-md bg-primary/10 px-3 font-bold tracking-wide text-primary whitespace-nowrap`}
      >
        {alt}
      </span>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={() => setImgFailed(true)}
      {...props}
    />
  );
};

export default BluestuffLogo;
